import { formatterNumberDecimals } from "helpers/mathDictionary";

export const GN3 = [
  {
    Header: 'Planta',
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.station.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Permiso',
    accessor: "permission",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.permission.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Existencia Final',
    accessor: "initialExistence",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.initialExistence.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.initialExistence ? formatterNumberDecimals(original.initialExistence, 2) : ''
  },
  {
    Header: 'S Litros',
    accessor: "ltExits",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.ltExits.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.ltExits ? formatterNumberDecimals(original.ltExits, 2) : ''
  },
  {
    Header: 'S Kilos',
    accessor: "kgExits",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.kgExits.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.kgExits ? formatterNumberDecimals(original.kgExits, 2) : ''
  },
  {
    Header: 'S Importe',
    accessor: "totalExits",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.totalExits.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.totalExits ? `$${formatterNumberDecimals(original.totalExits, 2)}` : ''
  },
  {
    Header: 'E Litros',
    accessor: "ltEntries",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.ltEntries.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.ltEntries ? formatterNumberDecimals(original.ltEntries, 2) : ''
  },
  {
    Header: 'E Kilos',
    accessor: "kgEntries",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.kgEntries.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.kgEntries ? formatterNumberDecimals(original.kgEntries, 2) : ''
  },
  {
    Header: 'E Importe',
    accessor: "totalEntries",
    filterable: true,
    filterMethod: (filter, row) =>
      row?.totalEntries.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => original.totalEntries ? `$${formatterNumberDecimals(original.totalEntries, 2)}` : ''
  },
]